import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getJobsStatus, runJob } from '@/services/ops.service';

export function useJobs() {
  const qc = useQueryClient();
  const query = useQuery({ queryKey: ['jobs'], queryFn: () => getJobsStatus() });
  const runMutation = useMutation({
    mutationFn: (jobName: string) => runJob(jobName),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['jobs'] }); },
  });
  return { jobs: query.data?.data ?? null, isLoading: query.isLoading, isError: query.isError, refetch: query.refetch, runJob: runMutation.mutate, isRunning: runMutation.isPending };
}
